import  React from  "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import '../styles/cv.css';


const Cv = () => {
	return (
	    <Layout>
		    <SEO title="Cv" />
			<main className="cv-content nav-spacing">
				<div className="cv-container">
					<div className="section border-bottom">
						<p className="section-title">CODING EXPERIENCE</p>
						<div className="section-content">
							<span className="section-period">
								<p className="section-period-title">Full-Stack<br />Developer</p>
								<p className="section-period-date">2021<br />Personal project</p>
							</span>
							<p className="content add-padding-top">Implemented an online sneaker selling platform </p><br />
							<span className="section-period">
								<p className="section-period-title">Project<br />Co-Lead</p>
								<p className="section-period-date">Nov - Dec 2020<br />Remote</p>
							</span>
							<p className="content add-padding-top">Successfully co-lead a team of 5 into the East African UNODC(United Nations Office of Drugs and Crime) hackathon where we built Citizen - a decentralized mobile appliaction built on top of the Celo Blockchain to track procurement funds as well as government projects.</p><br />
							<span className="section-period">
								<p className="section-period-title">Project<br />Lead</p>
								<p className="section-period-date">Sep 2020<br />Remote</p>
							</span>
							<p className="content add-padding-top">Ran point in building ZaoBora - an online platform and community that directly connects farmers with potential retailers and consumers; for the Andela sponsored BuildForSDG hackathon.</p><br />
							<span className="section-period">
								<p className="section-period-title">Frontend<br />Developer</p>
								<p className="section-period-date">2019<br />Eastleigh, Nairobi</p>
							</span>
							<p className="content add-padding-top">Designed and implemented the front-end of an e-commerce platform that would open up an online market for the existing traders in Eastleigh as well as other regions in the country</p>
						</div>
					</div>
					<div className="section border-bottom">
						<p className="section-title">EDUCATION</p>
						<div className="section-content">
							<span className="section-period">
								<p className="section-period-title">Andela Fellowship<br />Bootcamp</p>
								<p className="section-period-date">December 2018 <br />Andela HQ, Nairobi</p>
							</span>
							<p className="content add-padding-top">
								During this fast-paced Bootcamp, I was able to explore the Software Development process through collaborating in teams in building and launching a meetup application whilst demystifiying related concepts such as Version Control, Continuous Integration and Continuous Development.<br/><br/>
								Besides Bootcamp, other skills I have gained in the field through engaging myself in tech communities, guided research, mentorship and practical experience
							</p>
						</div>
					</div>
					<div className="section border-bottom">
						<p className="section-title">SKILLS</p>
						<div className="section-content">
							<div className="">
								<span className="section-period">
									<p className="section-period-title">Coding</p>
								</span>
								<p className="content add-padding-top"><mark>Proficient in</mark>: Javascript, Python, Version Control, object-oriented programming</p>
								<p className="content"><mark>Experience in</mark>: Flask, Django, Express, React, Redux, SQL, Bootstrap, CSS & HTML, Sass</p>
							</div>
							<div className="add-padding">
								<span className="section-period">
									<p className="section-period-title">Editing & Prototyping Software</p>
								</span>
								<p className="content add-padding-top">Adobe XD, Figma (beginner)</p>
							</div>
							<div className="add-padding">
								<span className="section-period">
									<p className="section-period-title">Project Management</p>
								</span>
								<p className="content add-padding-top">Tools - Pivotal tracker, Trello</p>
								<p className="content add-padding-top">Skills - Agile methodology(CI & CD)</p>
							</div>
							<div className="add-padding">
								<span className="section-period">
									<p className="section-period-title">Languages</p>
								</span>
								<p className="content add-padding-top">English (Conversational), Swahili</p>
							</div>
						</div>
					</div>
					<div className="section">
						<p className="section-title">VOLUNTEER WORK</p>
						<div className="section-content">
							<div className="">
								<span className="section-period">
									<p className="section-period-title">DevFest 2019</p>
									<p className="section-period-date">October 2019<br />Nairobi, KE</p>
								</span>
								<p className="content add-padding-top">Participated as a volunteer in the GDG DevFest 2019 - one of the biggest tech events in Kenya, tasked with ensuring rooms were available for the various sessions for that day, gifting attendees with goodie bags and badges while welcoming everyone and ensuring the event was successful.</p><br />
								<span className="section-period">
									<p className="section-period-title">buildForSDG hackathon</p>
									<p className="section-period-date">Aug 2020<br />Remote</p>
								</span>
								<p className="content add-padding-top">Participated as an active mentor in the 2020 buildForSDG online hackathon, where I helped empower learners build out projects in-line with the Software Development Goals by helping them navigate through the program and providing any necessary technical guidance.</p>
							</div>
						</div>
					</div>
				</div>
			</main>
	    </Layout>
	)
}

export default Cv;